import { INIT_ROOT } from '../actionTypes';

export default function appResources(state, action) {
  switch (action.type) {
    case INIT_ROOT:
      return action.payload.appResources;
    default:
      return state || {};
  }
}
